<template>
  <div>
    <page-header :title="$t('navbar.productEnablement')" />
    <page-content>
    </page-content>
  </div>
</template>

<script>
export default {
  name: 'ProductEnablement'
}
</script>
